import React, { useEffect, useState } from 'react'
import Countdown, { zeroPad } from 'react-countdown'
import { Password } from 'primereact/password'

import {
  Container,
  CodeDiv,
  OtpInput,
  InputButton,
  PassLabel,
  CountdownText,
  GrayText,
  Title,
  Logo
} from './style'
import { ReturnButton, MainText } from '../style3'

import LogoImg from '../../../assets/login/logo.png'
import LeftArrow from '../../../assets/login/left_arrow.svg'
import ApiService from '../../../services/ApiService'
import { ErrContainer } from '../MainBox/style'
import { CountdownRendererFn } from 'react-countdown'
interface CodeInputProps {
  setPage: (page: string) => void
}

const CodeInput: React.FC<CodeInputProps> = (props) => {
  const [otp, setOtp] = useState<string[]>(new Array(4).fill(''))
  const [time, setTime] = useState<number>(Date.now() + 60000)
  const [newPassword, setNewPassword] = useState<string>('')
  const [confirmNewPassword, setConfirmNewPassword] = useState<string>('')
  const [errMessage, setErrMessage] = useState<boolean>(false)
  const [errType, setErrType] = useState<string>('')

  useEffect(() => {
    setErrMessage(false)
    setErrType('')
  }, [otp, newPassword, confirmNewPassword])

  const changePage = (_page: string) => {
    props.setPage(_page)
  }

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    element: HTMLInputElement,
    index: number,
  ) => {
    if (isNaN(Number(element.value))) return false

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))])

    if (element.nextSibling && element.value !== '') {
      ;(element.nextSibling as HTMLInputElement).focus()
    }
  }

  function onKeyDown(
    event: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) {
    const element = event.target as HTMLInputElement
    if (event.keyCode === 8) {
      setOtp([...otp.map((d, idx) => (idx === index ? '' : d))])
      if (element.value === '') {
        ;(element.previousSibling as HTMLInputElement).focus()
      }
    }
  }

  const renderer: CountdownRendererFn = ({ minutes, seconds, completed }) => {
    if (completed) {
      return <span>a</span>
    } else {
      return (
        <span>
          envie novamente ({minutes}:{zeroPad(seconds)})
        </span>
      )
    }
  }

  const handleSubmit = () => {
    if (newPassword === confirmNewPassword) {
      setErrMessage(false)
      ApiService.auth.resetPasswordConfirm({
        resetToken: otp.join(''),
        newPassword,
      })
        .then((res) => {
          console.log(res)
          changePage('Main')
        })
        .catch((err) => {
          console.log(err)
          setErrMessage(true)
          setErrType('Código inválido')
        })
    } else {
      setErrMessage(true)
      setErrType('As duas senhas não estão iguais!')
    }
  }

  return (
    <Container>
      <Logo src={LogoImg} id='logo' alt='Logo da Dustre' />
      <Title>
        <ReturnButton
          onClick={() => {
            changePage('PassReset')
          }}
        >
          <img src={LeftArrow} alt='Botão de retorno' />
        </ReturnButton>
        <MainText>Esqueci a senha</MainText>
      </Title>

      <CodeDiv>
        <p>Digite o código enviado ao seu email</p>

        {otp.map((data, index) => {
          return (
            <OtpInput
              type='text'
              name='otp'
              maxLength={1}
              key={index}
              value={data}
              onChange={(e) => handleChange(e, e.target, index)}
              onFocus={(e) => e.target.select()}
              onKeyDown={(e) => onKeyDown(e, index)}
            />
          )
        })}

        <CountdownText>
          <GrayText>Se não recebeu um código, </GrayText>
          <Countdown renderer={renderer} date={time} />
        </CountdownText>
      </CodeDiv>

      <form>
        <PassLabel htmlFor='password'>Redefina sua senha</PassLabel>
        <Password
          onChange={(e) => setNewPassword(e.target.value)}
          className='passInput'
          placeholder='Digite sua senha'
          feedback={false}
          toggleMask
        ></Password>
        <Password
          onChange={(e) => setConfirmNewPassword(e.target.value)}
          className='passInput'
          placeholder='Digite sua senha novamente'
          feedback={false}
          toggleMask
        ></Password>
        {errMessage && <ErrContainer>{errType}</ErrContainer>}
          

        <InputButton
          onClick={() => handleSubmit()}
          type='button'
          value='Redefinir'
        />
      </form>
    </Container>
  )
}

export default CodeInput
